const TERM_UNIT_BY_STRUCTURE: Record<string, [singular: string, plural: string]> = {
  daily: ['day', 'days'],
  weekly: ['week', 'weeks'],
  biweekly: ['bi-weekly period', 'bi-weekly periods'],
  monthly: ['month', 'months'],
};

function normalizeStructure(structure: unknown): string {
  return String(structure ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '');
}

export function formatSubmissionTerm(term: unknown, structure: unknown): string {
  if (term === null || term === undefined || String(term).trim() === '') return '';

  const termLabel = String(term).trim();
  const [singular, plural] = TERM_UNIT_BY_STRUCTURE[normalizeStructure(structure)]
    ?? ['payment', 'payments'];
  const unit = Number(termLabel) === 1 ? singular : plural;

  return `${termLabel} ${unit}`;
}
